import { Link } from "react-router-dom";
import instagram from "../assets/instagram.png";
import x from "../assets/x.png";
import tiktok from "../assets/tiktok.png";

export default function Footer() {
  return (
    <>
      {/* <footer className="footer"> */}
      <div className="show-desktop" style={{ marginTop: 20 }}>
        <section>
          <div
            className="row"
            style={{
              margin: "0 10px",
              // backgroundColor: "#545454",
              borderRadius: 20,
            }}
          >
            <div className="col2 contact_us">
              <ContactUs />
            </div>
            <div className="col2">
              <FollowUs />
            </div>
          </div>
        </section>
      </div>
      <div className="show-mobile" style={{ marginTop: 20 }}>
        <section>
          <div
            className=""
            style={{
              // backgroundColor: "#737373",
              borderRadius: 20,
              margin: "10px",
            }}
          >
            <div className="row width_100 bottom_space">
              <div className="col1 contact_us center_me">
                <ContactUs />
              </div>
            </div>
            <div className="row width_100">
              <div className="col1">
                <FollowUs />
              </div>
            </div>
          </div>
        </section>
      </div>
      <CopyRight />
      <LegalStuff />
    </>
  );
}

function ContactUs() {
  return (
    <>
      <div className="show-desktop">
        {/* <WideLogo /> */}
        <p
          className="font_family_base center_me "
          style={{ fontWeight: "bold", color: "#FFFFFF" }}
        >
          Contact
        </p>
        <p>
          <a
            href="mailto:support@stakealerts.com"
            className="link_format font_family_base center_me "
            style={{ fontWeight: "bold", color: "##FFFFFF" }}
          >
            support@stakealerts.com
          </a>
        </p>
      </div>
      <div className="show-mobile">
        {/* <WideLogo /> */}
        <div>
          <p className="font_family_base center_me ">Contact</p>
        </div>
        <p>
          <a
            href="mailto:support@stakealerts.com"
            className="link_format font_family_base center_me "
          >
            support@stakealerts.com
          </a>
        </p>
      </div>
    </>
  );
}

function FollowUs() {
  return (
    <>
      {/* <p className="font_family_base">Follow Us</p> */}
      <div className="row center_me follow_me">
        {/* <a
          className="link_spacer"
          href="https://www.facebook.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={facebook} alt="Facebook"></img>
        </a> */}
        <a
          className="link_spacer"
          href="https://www.instagram.com/stakealerts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={instagram}
            alt="Instagram"
            width="50"
            height="50"
            style={{ height: 50, width: 50 }}
          />
        </a>
        <a
          className="link_spacer"
          href="https://x.com/StakeAlerts_"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={x}
            alt="X"
            width="50"
            height="50"
            style={{ height: 50, width: 50 }}
          />
        </a>
        <a
          className="link_spacer"
          href="https://www.tiktok.com/@stakealerts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={tiktok}
            alt="Tiktok"
            width="50"
            height="50"
            style={{ height: 50, width: 50 }}
          />
        </a>
      </div>
    </>
  );
}

function CopyRight() {
  const year = new Date().getFullYear();

  return (
    <div className="copyright font_family_base ">
      © {year} Copyright:{" "}
      {/* <Link to="https://stakealerts.com/" className="footer-links">
        {" "} */}
      stakealerts.com
      {/* </Link> */}
    </div>
  );
}

function LegalStuff() {
  return (
    <>
      <div className="copyright">
        <Link to="/terms" className="footer-links font_family_base link_blue">
          Terms and Conditions
        </Link>
      </div>
      <div className="copyright">
        <Link to="/privacy" className="footer-links font_family_base link_blue">
          Privacy Policy
        </Link>
      </div>
      <div className="copyright" style={{ marginBottom: 20 }}>
        <Link
          to="/responsible"
          className="footer-links font_family_base link_blue"
        >
          Responsible Gaming
        </Link>
      </div>
    </>
  );
}
